import React from 'react';
import ReactDOM from 'react-dom';

// order matters here! https://github.com/auth0/lock/issues/1018
import Auth0Lock from 'auth0-lock';
import 'babel-polyfill';
// order matters here!

import App from './App';
import registerServiceWorker from './registerServiceWorker';
import './index.css';

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js